import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  button: {
    position: 'absolute',
    right: 1,
    top: 1,
    color: 'gray'
  },
  layoutName: {
    marginTop: 18,
    textAlign: 'center',
    width: '100%'
  },
  containerImage: {
    padding: 16,
    display: 'flex',
    justifyContent: 'center'
  },
  image: {
    objectFit: 'contain',
    width: '100%',
    minWidth: 250,
    maxWidth: 700,
    maxHeight: '80vh',
    height: 'auto',
    display: 'block'
  }
}))

export default useStyles
